import React from "react";
import { get, orderBy } from "lodash";
import {
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  Box,
  Typography,
} from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ErrorValidation from "../../../ErrorValidation";
import useStyles from "./styles";
import UserProfileWidget from "Components/widgets/UserProfileWidget";

const SelectField = ({ register, ...props }) => {
  const classes = useStyles();
  return (
    <FormControl
      className={classes.formControl}
      fullWidth={true}
      variant="outlined"
    >
      <InputLabel
        shrink={true}
        id="select-field-helper-label"
        className={classes.InputLabel}
        error={props.error ? true : false}
        disabled={props.disabled}
      >
        {props.labelText ? props.labelText : props.label}
        {props.labelText ? (
          <span className="MuiInputLabel-asterisk">*</span>
        ) : (
          ""
        )}
      </InputLabel>

      {get(props, "extraInformation") ? (
        <Box marginTop={"20px"}>
          <Typography variant="body2" className="font-12 f-gray" mt={4}>
            {get(props, "extraInformation")}
          </Typography>
        </Box>
      ) : null}

      {props?.isTabSelection ? (
        <Box>
          <ToggleButtonGroup
            {...props}
            {...register}
            // value={props.value}
            exclusive
            // onChange={props.onChange}
            aria-label="target type"
            className={classes.toggleBtnGroup}
          >
            {props.options?.length &&
              props.options.map((item, i) => {
                return (
                  <ToggleButton
                    key={i.toString()}
                    value={item.name}
                    aria-label={item.name}
                  >
                    {item.value}
                  </ToggleButton>
                );
              })}
          </ToggleButtonGroup>
        </Box>
      ) : (
        <Select
          {...props}
          {...register}
          displayEmpty
          className={classes.selectEmpty}
          inputProps={{ "data-testid": "onChange1" }}
          labelId="select-field-helper-label"
          id="select-field-helper"
          IconComponent={ExpandMoreIcon}
          color="secondary"
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left",
            },
            getContentAnchorEl: null,
            PaperProps: {
              className: "select-menu-paper",
            },
          }}
          error={props.error ? true : false}
          value={props.value}
        >
          {get(props, "displayOption", []).map((res, key) => (
            <MenuItem value={res.id} key={key} className={classes.menuItem}>
              <Box display="flex" alignItems="center">
                {res.value}
              </Box>
            </MenuItem>
          ))}
          {get(props, "options", []).map((res, key) => {
            return (
              <MenuItem value={res.name} key={key} className={classes.menuItem}>
                {res.value ? res.value : res.name}
                {res.extraInfo ? (
                  <span className={`${classes.extraInfo} extra-info`}>
                    {res.extraInfo}
                  </span>
                ) : (
                  ""
                )}
              </MenuItem>
            );
          })}
          {orderBy(get(props, "users", []), "firstName").map((option, key) => {
            return (
              <MenuItem
                value={option.userid}
                key={key}
                className={`${classes.menuItem} ${
                  option?.isNewHighlight ? classes.newUser : ""
                }`}
              >
                <Box display="flex" alignItems="center">
                  <UserProfileWidget
                    firstName={option?.firstName}
                    lastName={option?.lastName}
                    url={get(option, "profileImage.fileName", "")}
                    icon={option?.icon}
                  />
                  <span className="user-name truncate-txt">{`${option?.firstName} ${option?.lastName}`}</span>
                </Box>
              </MenuItem>
            );
          })}
        </Select>
      )}

      {props.error && <ErrorValidation error={props.error} />}
      {props.showIndicator && (
        <span className={`${classes.dotIndicator} dot-indicator`}></span>
      )}
    </FormControl>
  );
};

export default SelectField;
